export default {
	title: 'actions',
	components: [{ title: 'actions', component: 'webhooks_gen_2' }],
};
